module.exports = __webpack_public_path__ + "img/bni.adc4b4b1.svg";